export interface CampaignRequestColumn {
    key: string;
    label: string;
    sortKey: string;
}

// All available columns for the Campaign Request results table.
// Single source of truth shared by CampaignRequestAccordionItem (picker)
// and CampaignRequestSearchResults (table).
export const ALL_AVAILABLE_COLUMNS: CampaignRequestColumn[] = [
    { key: 'patient_name', label: 'Patient Name', sortKey: 'patient_last_name' },
    { key: 'patient_email', label: 'Patient Email', sortKey: 'patient_email' },
    { key: 'patient_phone', label: 'Patient Phone', sortKey: 'patient_phone1' },
    { key: 'initial_contact_name', label: 'Initial Contact Name', sortKey: 'initial_last_name' },
    { key: 'initial_contact_email', label: 'Initial Contact Email', sortKey: 'initial_email' },
    { key: 'initial_contact_phone', label: 'Initial Contact Phone', sortKey: 'initial_phone' },
    { key: 'status', label: 'Status', sortKey: 'status' },
    { key: 'medical_reason', label: 'Medical Reason', sortKey: 'medical_reason' },
    { key: 'primary_medical_issue', label: 'Primary Medical Issue', sortKey: 'primary_medical_issue' },
    { key: 'coordinator', label: 'Coordinator', sortKey: 'patient_services_coordinator' },
    { key: 'created_date', label: 'Created Date', sortKey: 'created_date' },
    { key: 'prescreen_result', label: 'Prescreen Result', sortKey: 'prescreen_result' },
    { key: 'contact_attempts', label: 'Attempts', sortKey: 'contact_attempts_count' },
];

export const DEFAULT_VISIBLE_COLUMNS: string[] = [
    'patient_name',
    'patient_email',
    'initial_contact_name',
    'initial_contact_phone',
    'status',
    'medical_reason',
    'primary_medical_issue',
    'created_date',
];

// Parse a `visible_columns` URL value (comma-joined keys) into a validated key list.
// Returns DEFAULT_VISIBLE_COLUMNS when missing or yields no valid keys.
export const parseVisibleColumns = (raw: string | null): string[] => {
    if (raw) {
        const valid = new Set(ALL_AVAILABLE_COLUMNS.map(c => c.key));
        const parsed = raw.split(',').map(s => s.trim()).filter(k => valid.has(k));
        if (parsed.length) return parsed;
    }
    return DEFAULT_VISIBLE_COLUMNS;
};

// True when `selected` is exactly the default set (order-independent).
export const isDefaultSelection = (selected: string[]): boolean =>
    selected.length === DEFAULT_VISIBLE_COLUMNS.length &&
    selected.every(k => DEFAULT_VISIBLE_COLUMNS.includes(k));
